export default vars => hljs => {
  const RESERVED_WORDS = [
    'else',
    'elseif',
    'if',
    'while',
    'for',
    'endif',
    'is',
    'and',
    'or',
    'not',
  ];
  const BUILT_INS = [
    'sqr',
    'sqrt',
    'abs',
    'random',
    'roll',
    'show',
    'reset',
    'resetAll',
    'min',
    'max',
    'round',
    'visits',
  ];
  const LITERALS = ['false', 'true'];
  // The call to this function should return the variable names
  const VARIABLES = vars();

  // https://tc39.es/ecma262/#sec-literals-numeric-literals
  const decimalDigits = '[0-9](_?[0-9])*';
  const frac = `\\.(${decimalDigits})`;
  // DecimalIntegerLiteral, including Annex B NonOctalDecimalIntegerLiteral
  // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
  const decimalInteger = `0|[1-9](_?[0-9])*|0[0-7]*[89][0-9]*`;
  const NUMBER = {
    className: 'number',
    variants: [
      // DecimalLiteral
      {
        begin:
          `(\\b(${decimalInteger})((${frac})|\\.)?|(${frac}))` +
          `[eE][+-]?(${decimalDigits})\\b`,
      },
      { begin: `\\b(${decimalInteger})\\b((${frac})\\b|\\.)?|(${frac})\\b` },

      // DecimalBigIntegerLiteral
      { begin: `\\b(0|[1-9](_?[0-9])*)n\\b` },

      // NonDecimalIntegerLiteral
      { begin: '\\b0[xX][0-9a-fA-F](_?[0-9a-fA-F])*n?\\b' },
      { begin: '\\b0[bB][0-1](_?[0-1])*n?\\b' },
      { begin: '\\b0[oO][0-7](_?[0-7])*n?\\b' },

      // LegacyOctalIntegerLiteral (does not include underscore separators)
      // https://tc39.es/ecma262/#sec-additional-syntax-numeric-literals
      { begin: '\\b0[0-7]+n?\\b' },
    ],
    relevance: 0,
  };

  // Temporary match the mentions to create a node around them
  const MENTION = {
    className: 'mention',
    variants: [
      {
        match: /hljs-mention\.[a-zA-Z0-9-]+\[[a-zA-Z0-9-]+\]/,
      },
    ],
  };

  const keywords = {
    keyword: RESERVED_WORDS.join(' '),
    built_in: BUILT_INS.join(' '),
    literal: LITERALS.join(' '),
    variable: VARIABLES.join(' '),
  };

  return {
    name: 'Arcscript',
    aliases: ['as'],
    keywords,
    contains: [
      {
        beginKeywords: 'while if for',
      },
      hljs.QUOTE_STRING_MODE,
      hljs.APOS_STRING_MODE,
      hljs.NUMBER_MODE,
      hljs.C_NUMBER_MODE,
      NUMBER,
      MENTION,
    ],
  };
};
